import { render, staticRenderFns } from "./SurroundingAreaStrategyComponent.vue?vue&type=template&id=a82ff128&scoped=true&"
import script from "./SurroundingAreaStrategyComponent.vue?vue&type=script&lang=js&"
export * from "./SurroundingAreaStrategyComponent.vue?vue&type=script&lang=js&"
import style0 from "./SurroundingAreaStrategyComponent.vue?vue&type=style&index=0&id=a82ff128&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82ff128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
